import React from 'react';
import { useQuery } from 'jsonapi-react';
import { useTranslation } from 'react-i18next';
import { FeedCard } from '@/pages/feed/feed-card';
import Loader from '@/app/components/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { DashboardContent } from '@/layouts/dashboard';
import { PageContent, Page, PageSidebar } from '@/components/custom/page';

export function FeedPost(props) {
  const { uri } = props;

  const { t } = useTranslation();
  const { data = {}, isLoading, setData } = useQuery(['posts', props.slug]);
  const addComments = comment => {
    let post = data;
    post.comments.push(comment.data);
    post['comments-count'] = post.comments.length;
    setData({ ...post });
  };

  const breadcrumbs = {
    title: 'Comunidade',
    nav: [
      {
        route: '/feed',
        name: 'Fórum',
        isActive: false
      },
      {
        route: uri,
        name: 'Voltar',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <Page>
        <PageContent>
          {isLoading && <Loader />}
          {!isLoading && data && (
            <FeedCard
              key={data.id}
              post={data}
              addComments={addComments}
              setPost={setData}
            />
          )}
          {!isLoading && !data && (
            <EmptyState
              type="content"
              title={t('emptyState.contentNotAvaliable')}
              text={t('emptyState.contactATeacherText')}
            />
          )}
        </PageContent>
        <PageSidebar />
      </Page>
    </DashboardContent>
  );
}
